


























































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Watch } from 'vue-property-decorator';
import colors from 'vuetify/es5/util/colors';
import { loader, user } from '@/modules/shared/shared/store/namespaces';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import { UserGetters } from '@/modules/users/store/user.getters';
import { UserRole } from '@/modules/users/domain/user-role';

@Component
export default class DaycoRoleManagement extends Vue {
    selectedGroup: any = {};

    createRol: boolean = false;
    currentStep: number = 1;
    daycoGroupId: number = -1;
    daycoRol: number = -1;
    daycoRolName: string = '';
    daycoRolTransaction: boolean = false;
    daycoRolTransactionFinished: boolean = false;
    deletingGroup: boolean = false;
    deletingRol: boolean = false;
    editGroup: boolean = false;
    editRol: boolean = false;
    finishedText: string = '';
    headers: any[] = [
        { text: 'Grupo', sortable: true, value: 'name' },
        { text: 'Descripción', sortable: true, value: 'description' },
        { text: 'Rol asociado', sortable: true, value: 'rolName' },
    ];
    initialDaycoRol: number = -1;

    loadingText: string = '';
    loadingDeleteRolButton: boolean = false;
    menu: boolean = false;
    menuKey: number = 1;
    menuGroup: boolean = false;
    menuGroupKey: number = 1;
    page: number = 1;
    pages: number = 0;
    previousDaycoRol: number = -1;
    privileges: { c: boolean; r: boolean; u: boolean; d: boolean } = {
        c: false,
        r: false,
        u: false,
        d: false,
    };
    privilegesAD: { c: boolean; r: boolean; u: boolean; d: boolean } = {
        c: false,
        r: false,
        u: false,
        d: false,
    };
    rolDescriptionAux: string = '';
    rolNameAux: string = '';
    rolPrivilegesAux: {
        resourceId: number;
        resourceName: string;
        create: {
            privilegeId: number;
            active: boolean;
        };
        read: {
            privilegeId: number;
            active: boolean;
        };
        update: {
            privilegeId: number;
            active: boolean;
        };
        delete: {
            privilegeId: number;
            active: boolean;
        };
    }[] = [];
    rolTransaction: boolean = false;
    rolOptionsKey: number = 1;
    rolWindowIndex: number = 1;
    rules: {
        rolRules: any[];
    } = {
        rolRules: [
            (v: any) => !!v || 'Campo obligatorio',
            (v: any) => v !== -1 || 'Campo obligatorio',
        ],
    };
    search: string = '';
    setAllPrivilegesValue: boolean = false;
    snackbar: boolean = false;
    snackbarColor: string = '';
    snackbarText: string = '';
    steps: number = 2;
    windowKey: number = 1;

    $refs!: {
        form1: any;
        formRoles: any;
    };

    async mounted() {
        this.daycoRolTransaction = false;
        this.daycoRolTransactionFinished = false;

        EventBus.$emit(EventBusMessages.SHOW_LOADER);

        this.$store.commit('SET_LOADING_DAYCO_ROLES', true);

        await Promise.all([
            this.getRolesAndPrivileges(),
            this.getDaycoRoles(),
            this.getDaycoGroups(true),
            this.getDaycoGroups(false),
        ]);
        this.getRoles();
        this.$store.commit('SET_LOADING_DAYCO_ROLES', false);
        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    @Emit('closeDialog')
    closeDialog(snackbar, snackbarText, snackbarColor) {
        this.$emit('closeDialog', snackbar, snackbarText, snackbarColor);
    }

    @Watch('daycoRol')
    onDaycoRolChanged() {
        this.editRol = false;
    }

    @Watch('getDaycoRolesDataFailed')
    ongetDaycoRolesDataFailedChanged() {
        if (this.getDaycoRolesDataFailed) {
            setTimeout(() => {
                this.closeDialog(false, '', '');
            }, 7000);
        }
    }

    @Watch('setAllPrivilegesValue')
    onSetAllPrivilegesValueChanged() {
        if (this.createRol) {
            this.privilegeList.forEach((privilege: any) => {
                if (
                    privilege.resourceId !== 6 &&
                    privilege.resourceId !== 9 &&
                    privilege.resourceId !== 4 &&
                    privilege.resourceId !== 1 &&
                    privilege.resourceId !== 8
                ) {
                    if (privilege.resourceId === 2) {
                        privilege.create.active = true;
                    } else {
                        privilege.create.active = this.setAllPrivilegesValue;
                    }
                } else {
                    privilege.create.active = false;
                }
                if (privilege.resourceId !== 3 && privilege.resourceId !== 10) {
                    privilege.read.active = this.setAllPrivilegesValue;
                } else {
                    privilege.read.active = false;
                }
                if (
                    privilege.resourceId !== 2 &&
                    privilege.resourceId !== 4 &&
                    privilege.resourceId !== 6 &&
                    privilege.resourceId !== 3 &&
                    privilege.resourceId !== 9 &&
                    privilege.resourceId !== 1 &&
                    privilege.resourceId !== 8 &&
                    privilege.resourceId !== 10
                ) {
                    privilege.update.active = this.setAllPrivilegesValue;
                    privilege.delete.active = this.setAllPrivilegesValue;
                } else {
                    privilege.update.active = false;
                    privilege.delete.active = false;
                }
            });
        } else {
            if (this.rolPrivilegesAux && this.rolPrivilegesAux.length) {
                this.rolPrivilegesAux.forEach((privilege: any) => {
                    if (
                        privilege.resourceId !== 6 &&
                        privilege.resourceId !== 9 &&
                        privilege.resourceId !== 4 &&
                        privilege.resourceId !== 1
                    ) {
                        if (privilege.resourceId === 2) {
                            privilege.create.active = true;
                        } else {
                            privilege.create.active = this.setAllPrivilegesValue;
                        }
                    } else {
                        privilege.create.active = false;
                    }

                    if (privilege.resourceId !== 3 && privilege.resourceId !== 10) {
                        privilege.read.active = this.setAllPrivilegesValue;
                    } else {
                        privilege.read.active = false;
                    }
                    if (
                        privilege.resourceId !== 2 &&
                        privilege.resourceId !== 4 &&
                        privilege.resourceId !== 6 &&
                        privilege.resourceId !== 3 &&
                        privilege.resourceId !== 9 &&
                        privilege.resourceId !== 1
                    ) {
                        privilege.update.active = this.setAllPrivilegesValue;
                        privilege.delete.active = this.setAllPrivilegesValue;
                    } else {
                        privilege.update.active = false;
                        privilege.delete.active = false;
                    }
                });
            }
        }
    }

    get currentRol() {
        let currentRol: {
            id: number;
            name: string;
            description: string;
        } = {
            id: -1,
            name: '',
            description: '',
        };
        let daycoRol = this.daycoRol;

        if (this.daycoRoles && this.daycoRoles.length) {
            let rol = this.daycoRoles.filter(function(item: any) {
                return daycoRol === item.id;
            });
            if (rol && rol.length !== 0) {
                currentRol.id = rol[0].role.id;
                currentRol.name = rol[0].role.name;
                currentRol.description = rol[0].role.description;

                this.resetPrivilegeList();
                this.copyPrivileges(rol[0]);
                this.windowKey = this.windowKey === 1 ? 0 : 1;
                if (this.editRol) {
                    this.windowKey = this.windowKey === 1 ? 0 : 1;
                }
            }
        } else {
            this.windowKey = this.windowKey === 1 ? 0 : 1;
        }
        return currentRol;
    }

    get customerId() {
        const customer: any = localStorage.getItem('company');
        const customerId: any = JSON.parse(customer).id;
        return customerId;
    }

    get daycoGroups() {
        let daycoGroupsList: {
            name: string;
            description: string;
            mapped: boolean;
            rolName: string;
        }[] = [];

        if (
            this.$store.state.daycoGroups &&
            this.$store.state.daycoGroups.length &&
            this.$store.state.daycoGroupsMapped &&
            this.$store.state.daycoGroupsMapped.length
        ) {
            this.$store.state.daycoGroups.forEach(daycoGroup => {
                if (daycoGroup.cn !== 'G_PortalCliente') {
                    let mappedGroup = this.$store.state.daycoGroupsMapped.filter(groupMapped => {
                        return groupMapped.name === daycoGroup.cn;
                    });
                    let groupIsMapped = mappedGroup && mappedGroup.length ? true : false;
                    let rolName = groupIsMapped ? mappedGroup[0].customerRole.role.name : 'zzz';
                    let daycoGroupsAux: {
                        name: string;
                        description: string;
                        mapped: boolean;
                        rolName: string;
                    } = {
                        name: daycoGroup.cn,
                        description: daycoGroup.description,
                        mapped: groupIsMapped,
                        rolName: rolName,
                    };
                    daycoGroupsList.push(daycoGroupsAux);
                }
            });
        }
        return daycoGroupsList;
    }

    get daycoRoles() {
        return this.$store.state.daycoRoles;
    }

    get daycoRolesTransactionFailed() {
        if (this.$store.state.failedDaycoRolTransaction === 'Mapping') {
            this.finishedText =
                'Ocurrió un error en la asociación de roles, por favor intente de nuevo';
            return true;
        } else {
            if (this.$store.state.failedDaycoRolTransaction === 'DeleteMap') {
                this.finishedText =
                    'Ocurrió un error eliminando la asociación, por favor intente de nuevo';
                return true;
            } else {
                if (this.$store.state.failedDaycoRolTransaction === 'UpdateMapping') {
                    this.finishedText = 'Actualización fallida';
                    return true;
                } else {
                    return false;
                }
            }
        }
    }

    get form1IsValid() {
        return this.$refs.form1.validate();
    }

    get formRolesIsValid() {
        return this.$refs.formRoles.validate();
    }

    get getDaycoRolesDataFailed() {
        if (
            this.finishedText === 'Carga de datos fallida' ||
            this.$store.state.failedContactTransaction === 'ContactFormData' ||
            this.$store.state.failedDaycoRolTransaction === 'DaycoRoles' ||
            this.$store.state.failedDaycoRolTransaction === 'DaycoGroups'
        ) {
            this.finishedText = 'Carga de datos fallida';
            return true;
        } else {
            return false;
        }
    }

    get privilegeList() {
        let privilegeList: {
            resourceId: number;
            resourceName: string;
            create: {
                privilegeId: number;
                active: boolean;
            };
            read: {
                privilegeId: number;
                active: boolean;
            };
            update: {
                privilegeId: number;
                active: boolean;
            };
            delete: {
                privilegeId: number;
                active: boolean;
            };
        }[] = [];

        let privileges = this.$store.state.privileges;
        let privilegeResources = this.$store.state.privilegeResources;

        if (privileges && privileges.length && privilegeResources && privilegeResources.length) {
            privilegeResources.forEach((privilegeResource: any) => {
                let privilegesPerResource = privileges.filter(function(privilege: any) {
                    return privilegeResource.id === privilege.resource.id;
                });
                let auxPrivilege: {
                    resourceId: number;
                    resourceName: string;
                    create: {
                        privilegeId: number;
                        active: boolean;
                    };
                    read: {
                        privilegeId: number;
                        active: boolean;
                    };
                    update: {
                        privilegeId: number;
                        active: boolean;
                    };
                    delete: {
                        privilegeId: number;
                        active: boolean;
                    };
                } = {
                    resourceId: -1,
                    resourceName: '',
                    create: {
                        privilegeId: -1,
                        active: false,
                    },
                    read: {
                        privilegeId: -1,
                        active: false,
                    },
                    update: {
                        privilegeId: -1,
                        active: false,
                    },
                    delete: {
                        privilegeId: -1,
                        active: false,
                    },
                };
                privilegesPerResource.forEach((privilegeItem: any) => {
                    auxPrivilege.resourceId = privilegeResource.id;
                    auxPrivilege.resourceName = privilegeResource.displayName;
                    if (privilegeItem.action.name === 'create') {
                        auxPrivilege.create.privilegeId = privilegeItem.id;
                        if (auxPrivilege.resourceId === 2) {
                            auxPrivilege.create.active = true;
                        }
                    } else {
                        if (privilegeItem.action.name === 'read') {
                            auxPrivilege.read.privilegeId = privilegeItem.id;
                        } else {
                            if (privilegeItem.action.name === 'update') {
                                auxPrivilege.update.privilegeId = privilegeItem.id;
                            } else {
                                if (privilegeItem.action.name === 'delete') {
                                    auxPrivilege.delete.privilegeId = privilegeItem.id;
                                }
                            }
                        }
                    }
                });
                privilegeList.push(auxPrivilege);
            });
        }
        return privilegeList;
    }

    get privilegeResourceList() {
        return this.$store.state.privilegeResources;
    }

    get rolTransactionFailed() {
        let rolTransactionFailed = false;
        if (this.$store.state.failedRolTransaction === 'CreateRol') {
            this.openSnackbar('Creación de rol fallida, por favor intente de nuevo', 'red');
            rolTransactionFailed = true;
        } else {
            if (this.$store.state.failedRolTransaction === 'UpdateRol') {
                this.openSnackbar('Modificación de rol fallida, por favor intente de nuevo', 'red');
                rolTransactionFailed = true;
            } else {
                if (this.$store.state.failedRolTransaction === 'DeleteRol') {
                    this.openSnackbar(
                        'Eliminación de rol fallida, por favor intente de nuevo',
                        'red',
                    );
                    rolTransactionFailed = true;
                }
            }
        }
        return rolTransactionFailed;
    }

    changeWindow(windowIndex: number) {
        let customerRolIndex = this.daycoRoles.map(e => e.id).indexOf(this.daycoRol);
        if (customerRolIndex === -1) {
            this.daycoRol = -1;
        }
        this.rolWindowIndex = windowIndex;

        this.menu = false;
        if (windowIndex === 1) {
            this.setAllPrivilegesValue = false;
            this.rolPrivilegesAux = [];
            this.editRol = false;
            this.setPreviousDaycoRol(this.daycoRol);

            if (this.daycoRol === -1) {
                this.$refs.form1.reset();
            }
            this.daycoRol = -1;

            this.$refs.formRoles.reset();
            if (this.createRol) {
                this.resetCurrentRol();
                this.resetPrivilegeList();
            }
            this.createRol = false;
            this.daycoRol = this.previousDaycoRol;

            this.windowKey = this.windowKey === 1 ? 0 : 1;
        } else {
            if (this.createRol) {
                this.setPreviousDaycoRol(this.daycoRol);
                if (this.$refs.formRoles) {
                    this.$refs.formRoles.reset();
                }
                this.daycoRol = -1;
                this.$refs.form1.reset();
                this.resetPrivilegeList();
            }
        }
    }

    changeWindowCreateRol(windowIndex: number) {
        this.createRol = true;
        this.changeWindow(windowIndex);
    }

    copyPrivileges(rol: any) {
        this.privilegeResourceList.forEach((privilegeResource: any) => {
            let auxPrivileges = rol.role.rolePrivileges.filter(function(itemP: any) {
                return itemP.privilege.resource.id === privilegeResource.id;
            });
            if (auxPrivileges && auxPrivileges.length) {
                let privilegeIndex = this.privilegeList
                    .map(e => e.resourceId)
                    .indexOf(privilegeResource.id);
                if (privilegeIndex !== -1) {
                    auxPrivileges.forEach((item: any) => {
                        if (item.privilege.action.name === 'create') {
                            this.privilegeList[privilegeIndex].create.active = true;
                        } else {
                            if (item.privilege.action.name === 'read') {
                                this.privilegeList[privilegeIndex].read.active = true;
                            } else {
                                if (item.privilege.action.name === 'update') {
                                    this.privilegeList[privilegeIndex].update.active = true;
                                } else {
                                    if (item.privilege.action.name === 'delete') {
                                        this.privilegeList[privilegeIndex].delete.active = true;
                                    }
                                }
                            }
                        }
                    });
                }
            }
        });
    }

    closeSnackbar() {
        this.snackbar = false;
        this.snackbarText = '';
    }

    async deleteGroup() {
        this.loadingText = 'Eliminando rol del grupo...';
        this.finishedText =
            "El grupo '" + this.selectedGroup.name + "' se le retiro su rol exitosamente";
        this.daycoRolTransaction = true;
        this.deletingGroup = true;
        let rolToBeDeletedName = this.currentRol.name;
        await this.$store.dispatch('deleteDaycoGroup', this.daycoGroupId);
        if (!this.daycoRolesTransactionFailed) {
            await this.$store.dispatch('getDaycoRoles');
        }
        this.daycoRolTransactionFinished = true;
        this.menuGroup = false;
        this.deletingGroup = false;

        let messageColor = '';
        if (!this.daycoRolesTransactionFailed) {
            messageColor = 'green';
        } else {
            messageColor = 'red';
        }
        this.closeDialog(true, this.finishedText, messageColor);
    }

    customerContactSelectedWithoutCustomer() {
        let customerPrivilege = this.privilegeList.filter((privilege: any) => {
            return privilege.resourceId === 8;
        })[0];
        if (!customerPrivilege.read.active) {
            let customerContactPrivilege = this.privilegeList.filter((privilege: any) => {
                return privilege.resourceId === 12;
            })[0];
            if (
                customerContactPrivilege.create.active ||
                customerContactPrivilege.read.active ||
                customerContactPrivilege.update.active ||
                customerContactPrivilege.delete.active
            ) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    async deleteRol() {
        this.deletingRol = true;

        let rolToBeDeleted: {
            customerId: number;
            rolId: number;
        } = {
            customerId: this.customerId,
            rolId: -1,
        };
        let customerRolIndex = this.daycoRoles.map(e => e.id).indexOf(this.daycoRol);
        if (customerRolIndex !== -1) {
            rolToBeDeleted.rolId = this.daycoRoles[customerRolIndex].role.id;
        }
        let rolToBeDeletedName = this.currentRol.name;

        let mappedGroup = this.$store.state.daycoGroupsMapped.filter(groupMapped => {
            return groupMapped.customerRole.role.id === rolToBeDeleted.rolId;
        });
        if (mappedGroup && mappedGroup.length) {
            await Promise.all(
                mappedGroup.map(group => {
                    this.$store.dispatch('deleteDaycoGroup', group.id);
                }),
            );
        }
        if (!this.daycoRolesTransactionFailed) {
            await this.$store.dispatch('deleteRol', rolToBeDeleted);
        }
        if (!this.daycoRolesTransactionFailed) {
            await Promise.all([
                this.getDaycoRoles(),
                this.getDaycoGroups(true),
                this.getDaycoGroups(false),
            ]);
        }
        this.menu = false;
        this.deletingRol = false;
        if (!this.rolTransactionFailed) {
            this.openSnackbar(
                "El rol '" + rolToBeDeletedName + "' fue eliminado exitosamente",
                'success',
            );
        }

        this.changeWindow(1);
        this.previousStep(this.currentStep);
    }

    displayContactNames(lastName: string, name: string) {
        if (lastName) {
            if (name) {
                return lastName + ', ' + name;
            } else {
                return lastName;
            }
        } else {
            if (name) {
                return name;
            } else {
                return 'No especificado';
            }
        }
    }

    displayContactRoles(contactRolesIds: number[]) {
        let contactRolesNames: string[] = [];
        for (let i = 0; i < contactRolesIds.length; i++) {
            let rolName = this.daycoRoles.filter(function(item: any) {
                return item.id === contactRolesIds[i];
            });

            if (rolName && rolName.length) {
                contactRolesNames.push(rolName[0].role.name);
            }
        }
        return contactRolesNames.join(', ');
    }

    async getDaycoGroups(mapped: boolean) {
        await this.$store.dispatch('getDaycoGroups', mapped);
    }

    async getDaycoRoles() {
        await this.$store.dispatch('getDaycoRoles');
    }

    getRoles() {
        const role: any = localStorage.getItem('role');
        const privileges: any = this.roles;
        for (let index = 0; index < privileges.rolePrivileges.length; index++) {
            if (privileges.rolePrivileges[index].privilege.resource.name == 'Roles') {
                if (privileges.rolePrivileges[index].privilege.action.name == 'create') {
                    this.privileges.c = true;
                } else if (privileges.rolePrivileges[index].privilege.action.name == 'read') {
                    this.privileges.r = true;
                } else if (privileges.rolePrivileges[index].privilege.action.name == 'update') {
                    this.privileges.u = true;
                } else if (privileges.rolePrivileges[index].privilege.action.name == 'delete') {
                    this.privileges.d = true;
                }
            }
        }

        for (let index = 0; index < privileges.rolePrivileges.length; index++) {
            if (privileges.rolePrivileges[index].privilege.resource.name == 'ADGroups') {
                if (privileges.rolePrivileges[index].privilege.action.name == 'create') {
                    this.privilegesAD.c = true;
                } else if (privileges.rolePrivileges[index].privilege.action.name == 'read') {
                    this.privilegesAD.r = true;
                } else if (privileges.rolePrivileges[index].privilege.action.name == 'update') {
                    this.privilegesAD.u = true;
                } else if (privileges.rolePrivileges[index].privilege.action.name == 'delete') {
                    this.privilegesAD.d = true;
                }
            }
        }
    }

    async getRolesAndPrivileges() {
        const company: any = localStorage.getItem('company');
        await this.$store.dispatch(
            'getCustomerRolesStatusesResourcesPrivileges',
            JSON.parse(company).id,
        );
    }

    groupEdition() {
        this.editGroup = !this.editGroup;
    }

    isRolAdministrator(daycoRol: number) {
        if (daycoRol === 64) {
            return true;
        } else {
            let customerRolIndex = this.daycoRoles.map(e => e.id).indexOf(this.daycoRol);
            if (customerRolIndex !== -1) {
                return this.daycoRoles[customerRolIndex].role.id === 64;
            } else {
                return false;
            }
        }
    }

    async mappGroupAndRol() {
        if (this.$refs.form1.validate()) {
            if (!this.selectedGroup.mapped) {
                this.loadingText = 'Asociando grupo y rol...';
                this.daycoRolTransaction = true;
                let daycoRolSelected = this.daycoRoles.filter(customerRol => {
                    return customerRol.id === this.daycoRol;
                });
                if (daycoRolSelected && daycoRolSelected.length) {
                    let mappedRol: {
                        name: string;
                        customerRole: any;
                    } = {
                        name: this.selectedGroup.name,
                        customerRole: daycoRolSelected[0],
                    };
                    await this.$store.dispatch('mapDaycoRolAndGroup', mappedRol);
                    this.rolTransaction = false;
                    this.daycoRolTransactionFinished = true;

                    this.finishedText =
                        "El grupo '" +
                        this.selectedGroup.name +
                        "' fue mapeado al rol '" +
                        mappedRol.customerRole.role.name +
                        "' exitosamente";
                    let messageColor = '';
                    if (!this.daycoRolesTransactionFailed) {
                        messageColor = 'green';
                    } else {
                        messageColor = 'red';
                    }
                    this.closeDialog(true, this.finishedText, messageColor);
                }
            } else {
                this.loadingText = 'Asociando grupo y rol...';
                this.daycoRolTransaction = true;
                let daycoRolSelected = this.daycoRoles.filter(customerRol => {
                    return customerRol.id === this.daycoRol;
                });
                if (daycoRolSelected && daycoRolSelected.length) {
                    let mappedRol: {
                        id: number;
                        name: string;
                        customerRole: any;
                    } = {
                        id: this.daycoGroupId,
                        name: this.selectedGroup.name,
                        customerRole: daycoRolSelected[0],
                    };
                    await this.$store.dispatch('updateMappingDaycoRolAndGroup', mappedRol);
                    this.daycoRolTransactionFinished = true;

                    this.finishedText =
                        "El grupo'" +
                        this.selectedGroup.name +
                        "' fue mapeado al rol '" +
                        mappedRol.customerRole.role.name +
                        "' exitosamente";
                    let messageColor = '';
                    if (!this.daycoRolesTransactionFailed) {
                        messageColor = 'green';
                    } else {
                        messageColor = 'red';
                    }
                    this.closeDialog(true, this.finishedText, messageColor);
                }
            }
        }
    }

    async nextStep(n: number) {
        // if (await this.formIsValid(n)) {
        if (n === 1 && this.selectedGroup.mapped) {
            this.setDaycoRol();
        }

        if (n !== 1 || this.selectedGroup.name) {
            if (n === this.steps) {
                this.currentStep = 1;
            } else {
                this.currentStep = n + 1;
            }
        }
        //}
    }

    openGroupDeletionMenu() {
        this.menuGroup = true;
        this.menuGroupKey = this.menuGroupKey === 1 ? 0 : 1;
    }

    async openRolDeletionMenu(daycoRol: number, rolName: string) {
        this.menu = true;
        //this.loadingDeleteRolButton = false;
        this.menuKey = this.menuKey === 1 ? 0 : 1;
    }

    openSnackbar(message: string, color: string) {
        this.closeSnackbar();
        this.snackbarText = message;
        this.snackbarColor = color;
        this.snackbar = true;
    }

    privilegesEmpty() {
        let empty = true;
        this.privilegeList.forEach((privilege: any) => {
            if (
                (privilege.update.active ||
                    privilege.delete.active ||
                    privilege.read.active ||
                    privilege.create.active) &&
                privilege.resourceId !== 2
            ) {
                empty = false;
            }
        });
        return empty;
    }

    previousStep(n: number) {
        this.initialDaycoRol = -1;
        if (n === 2) {
            this.daycoRol = -1;
            this.$refs.form1.reset();
        }
        if (n === 1) {
            this.currentStep = 1;
        } else {
            this.currentStep = n - 1;
        }
    }

    readPrivilegesActive() {
        let readPrivilegesActive = true;
        this.privilegeList.forEach((privilege: any) => {
            if ((privilege.update.active || privilege.delete.active) && !privilege.read.active) {
                readPrivilegesActive = false;
            }
        });
        return readPrivilegesActive;
    }

    resetCurrentRol() {
        this.currentRol.id = -1;
        this.currentRol.name = '';
        this.currentRol.description = '';
    }

    resetPrivilegeList() {
        this.privilegeList.forEach((privilege: any) => {
            if (privilege.resourceId === 2) {
                privilege.create.active = true;
            } else {
                privilege.create.active = false;
            }
            privilege.read.active = false;
            privilege.update.active = false;
            privilege.delete.active = false;
        });
    }

    rolEdition() {
        this.editRol = !this.editRol;
        if (this.editRol) {
            this.rolNameAux = this.currentRol.name;
            this.rolDescriptionAux = this.currentRol.description;
            this.privilegeList.forEach(item => {
                this.rolPrivilegesAux.push(Object.assign({}, item));
            });
        } else {
            this.setAllPrivilegesValue = false;
            this.currentRol.name = this.rolNameAux;
            this.currentRol.description = this.rolDescriptionAux;
            this.resetPrivilegeList();
            this.rolPrivilegesAux.forEach(item => {
                let privilegeIndex = this.privilegeList
                    .map(e => e.resourceId)
                    .indexOf(item.resourceId);
                if (privilegeIndex !== -1) {
                    this.privilegeList[privilegeIndex].create.active = item.create.active;

                    this.privilegeList[privilegeIndex].read.active = item.read.active;

                    this.privilegeList[privilegeIndex].update.active = item.update.active;

                    this.privilegeList[privilegeIndex].delete.active = item.delete.active;
                }
            });
            this.rolNameAux = '';
            this.rolDescriptionAux = '';
            this.rolPrivilegesAux = [];
            this.windowKey = this.windowKey === 1 ? 0 : 1;
        }
    }

    selectGroup(item) {
        if (this.privilegesAD.c || this.privilegesAD.u || this.privilegesAD.d) {
            this.selectedGroup = item;
            this.nextStep(this.currentStep);
        }
    }

    setDaycoRol() {
        let mappedGroup = this.$store.state.daycoGroupsMapped.filter(groupMapped => {
            return groupMapped.name === this.selectedGroup.name;
        });
        if (mappedGroup && mappedGroup.length) {
            this.daycoRol = mappedGroup[0].customerRole.id;
            this.initialDaycoRol = mappedGroup[0].customerRole.id;
            this.daycoRolName = mappedGroup[0].customerRole.role.name;
            this.daycoGroupId = mappedGroup[0].id;
        }
    }

    setPreviousDaycoRol(daycoRol) {
        if (daycoRol !== -1) {
            this.previousDaycoRol = daycoRol;
        }
    }

    async submitRol() {
        if (this.formRolesIsValid) {
            if (!this.privilegesEmpty()) {
                if (!this.customerContactSelectedWithoutCustomer()) {
                    if (this.readPrivilegesActive()) {
                        if (this.createRol) {
                            let rolToBeCreated = this.transformRolToCreate();
                            this.rolTransaction = true;
                            await this.$store.dispatch('createRol', rolToBeCreated);
                            if (!this.rolTransactionFailed) {
                                await this.$store.dispatch('getDaycoRoles');
                            }
                            this.rolTransaction = false;
                            if (!this.rolTransactionFailed) {
                                this.openSnackbar(
                                    "El rol '" + rolToBeCreated.name + "' fue creado exitosamente",
                                    'success',
                                );
                            }
                            this.changeWindow(1);
                        } else {
                            let rolToBeUpdated = this.transformRolToUpdate();
                            this.rolTransaction = true;
                            await this.$store.dispatch('updateRol', rolToBeUpdated);
                            if (!this.rolTransactionFailed) {
                                await this.$store.dispatch('getDaycoRoles');
                            }
                            this.rolTransaction = false;
                            if (!this.rolTransactionFailed) {
                                this.openSnackbar(
                                    "El rol '" +
                                        rolToBeUpdated.name +
                                        "' fue modificado exitosamente",
                                    'success',
                                );
                            }
                            this.changeWindow(1);
                        }
                    } else {
                        this.openSnackbar(
                            "Debes seleccionar el privilegio 'Consultar' cuando selecciones los privilegios 'Modificar' o 'Eliminar'",
                            'red',
                        );
                    }
                } else {
                    this.openSnackbar(
                        "Debes seleccionar el privilegio 'Consultar Cliente' cuando selecciones algun privilegio de 'Contactos del Cliente'",
                        'red',
                    );
                }
            } else {
                this.openSnackbar('Debes seleccionar al menos un privilegio', 'red');
            }
        }
    }

    transformRolToCreate() {
        let rol: {
            name: string;
            description: string;
            customerId: number;
            rolesPrivileges: {
                privilege: number;
            }[];
        } = {
            name: '',
            description: '',
            customerId: -1,
            rolesPrivileges: [],
        };

        rol.name = this.currentRol.name;
        rol.description = this.currentRol.description;
        rol.customerId = this.customerId;

        this.privilegeList.forEach((privilege: any) => {
            let auxPrivilege: {
                privilege: number;
            } = {
                privilege: -1,
            };
            if (privilege.create.active) {
                auxPrivilege.privilege = privilege.create.privilegeId;
                rol.rolesPrivileges.push(Object.assign({}, auxPrivilege));
            }
            if (privilege.read.active) {
                auxPrivilege.privilege = privilege.read.privilegeId;
                rol.rolesPrivileges.push(Object.assign({}, auxPrivilege));
            }
            if (privilege.update.active) {
                auxPrivilege.privilege = privilege.update.privilegeId;
                rol.rolesPrivileges.push(Object.assign({}, auxPrivilege));
            }
            if (privilege.delete.active) {
                auxPrivilege.privilege = privilege.delete.privilegeId;
                rol.rolesPrivileges.push(Object.assign({}, auxPrivilege));
            }
        });

        return rol;
    }

    transformRolToUpdate() {
        let rol: {
            id: number;
            name: string;
            description: string;
            privileges: {
                privilege: {
                    id: number;
                };
            }[];
        } = {
            id: -1,
            name: '',
            description: '',
            privileges: [],
        };

        rol.id = this.currentRol.id;
        rol.name = this.currentRol.name;
        rol.description = this.currentRol.description;

        this.privilegeList.forEach((privilege: any) => {
            if (privilege.create.active) {
                let auxPrivilege: {
                    privilege: {
                        id: number;
                    };
                } = {
                    privilege: {
                        id: -1,
                    },
                };
                auxPrivilege.privilege.id = privilege.create.privilegeId;
                rol.privileges.push(Object.assign({}, auxPrivilege));
            }
            if (privilege.read.active) {
                let auxPrivilege: {
                    privilege: {
                        id: number;
                    };
                } = {
                    privilege: {
                        id: -1,
                    },
                };
                auxPrivilege.privilege.id = privilege.read.privilegeId;
                rol.privileges.push(Object.assign({}, auxPrivilege));
            }
            if (privilege.update.active) {
                let auxPrivilege: {
                    privilege: {
                        id: number;
                    };
                } = {
                    privilege: {
                        id: -1,
                    },
                };
                auxPrivilege.privilege.id = privilege.update.privilegeId;
                rol.privileges.push(Object.assign({}, auxPrivilege));
            }
            if (privilege.delete.active) {
                let auxPrivilege: {
                    privilege: {
                        id: number;
                    };
                } = {
                    privilege: {
                        id: -1,
                    },
                };
                auxPrivilege.privilege.id = privilege.delete.privilegeId;
                rol.privileges.push(Object.assign({}, auxPrivilege));
            }
        });
        return rol;
    }

    @user.Getter(UserGetters.GET_USER_ROLE)
    roles!: UserRole;
}
